import AMap from 'AMap'
// import AMapUI from 'AMapUI'
export default {
  data() {
    return {
      errorAddr: false, // 是否搜到结果
      gaodemap: null,
      mapMark: null,
      geocoder: null,
      addrKey: ''
    }
  },
  mounted() {
    this.initAmap()
  },
  methods: {
    // 初始化高德地图
    initAmap() {
      this.gaodemap = new AMap.Map('amap-container', {
        zoom: 13,
        center: [116.39, 39.9]
      })
      this.gaodemap.on('click', (e) => {
        this.addMark(e.lnglat)
        this.regeoCode(e.lnglat)
      })
    },
    // 加标记点
    addMark(lnglat) {
      if (this.mapMark === null) {
        this.mapMark = new AMap.Marker()
        this.gaodemap.add(this.mapMark)
      }
      this.mapMark.setPosition([lnglat.lng, lnglat.lat])
      this.gaodemap.setFitView(this.mapMark)
    },
    // 根据输入搜索经纬度
    searchAddr() {
      AMap.plugin('AMap.Geocoder', () => {
        if (!this.geocoder) {
          this.geocoder = new AMap.Geocoder()
        }
        this.geocoder.getLocation(this.addrKey, (status, result) => {
          if (status === 'complete' && result.geocodes.length) {
            this.errorAddr = false
            const lnglat = result.geocodes[0].location
            this.addMark(lnglat)
            this.setAddrInfo(result.geocodes[0].addressComponent, result.geocodes[0].formattedAddress, lnglat)
          } else if (status === 'no_data') {
            this.errorAddr = true
          }
        })
      })
    },
    // 根据选点填充
    regeoCode(lnglat) {
      if (!this.geocoder) {
        this.geocoder = new AMap.Geocoder()
      }

      this.geocoder.getAddress(lnglat, (status, result) => {
        if (status === 'complete' && result.regeocode) {
          this.setAddrInfo(result.regeocode.addressComponent, result.regeocode.formattedAddress, lnglat)
        } if (status === 'no_data') {
          this.setAddrInfo({}, '', '')
        }
      })
    },
    // 根据地址填充
    setAddrInfo(addrObj, addr, lnglat) {
      this.libForm.p_name = addrObj.province || ''
      this.libForm.city_name = addrObj.city || addrObj.province || ''
      this.libForm.ad_name = addrObj.district || ''
      this.libForm.address = addr || ''
      this.libForm.location_jingdu = lnglat.lng || ''
      this.libForm.location_weidu = lnglat.lat || ''
    }
  }
}
